document.addEventListener('DOMContentLoaded', toggleMediaDisplay);

function toggleMediaDisplay() {
  const isMobile = window.innerWidth < 769;
  const desktopElement = document.querySelector('.hero__media-container .desktop');
  const mobileElement = document.querySelector('.hero__media-container .mobile');
  const videoElement = document.querySelector('.boa-section-hero-video');
  
  if (!videoElement) {
    return;
  } 
  
  // Show video on desktop if it was hidden
  if (videoElement.classList.contains('hidden') && !isMobile) {
    videoElement.classList.remove('hidden');
  }
  
  if (desktopElement && isMobile) {
    desktopElement.remove();
    return;
  }
  
  if (mobileElement && !isMobile) {
    mobileElement.remove();
    return;
  }
}
